import { findElementsWithAnimations } from '../../interactions/utils/find-elements-with-animations';
import { triggerAnimationsForElements } from '../../interactions/utils/trigger-animations-for-elements';

/**
 * Retrigger nested entrance animations after a destination slide becomes visible.
 *
 * Inactive slides are `display: none`, so `animateElement()` skips them on load.
 * Call this after the incoming slide has faded to opacity 1. Triggering at
 * `display: block` while opacity is still 0 plays the animation off-screen.
 *
 * @param {JQuery} $slide Destination slide that is now faded in.
 */
export const triggerDestinationSlideAnimations = ($slide: JQuery): void => {
  const slideOpacity = parseFloat($slide.css('opacity'));

  if (0 === $slide.length || !$slide.is(':visible')) {
    return;
  }

  // Incoming slides are `:visible` at opacity 0; do not start entrance animation until the fade has finished.
  if (!Number.isNaN(slideOpacity) && 0 === slideOpacity) {
    return;
  }

  const $elementsWithAnimations = findElementsWithAnimations($slide);

  if (0 === $elementsWithAnimations.length) {
    return;
  }

  triggerAnimationsForElements($elementsWithAnimations, {
    shouldTrigger: () => $slide.hasClass('et-pb-active-slide'),
  });
};
